import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import * as auth from "../Auth"
import {http_auth, REFRESH_TOKEN} from "../../../utility/Utils"
import {toast} from "react-toastify"

export const testSmsConfig = createAsyncThunk('config/testSmsConfig', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/integration/v1/sms/test-sms-config`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const saveConfiguration = createAsyncThunk('config/saveConfiguration', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/admin/v1/system-config/save-list`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const getEpiguApplicationData = createAsyncThunk('config/getEpiguApplicationData', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/admin/v1/admin/load-from-epigu?epiguId=${data}`)
        if (response.data?.data === null) return rejectWithValue(response.data.message)

        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const configSlice = createSlice({
    name: 'config',
    initialState: {
        status: null,
        execute: null,

        current_page: 0,
        count_item: 0,
        total_count: 0,
        isLoading: false
    },
    reducers: {},
    extraReducers: {
        [testSmsConfig.fulfilled](state, action) {
            state.status = action.payload?.status
            state.isLoading = false
        },
        [getEpiguApplicationData.fulfilled](state, action) {
            if (action.payload === undefined) {
                toast.error("Ariza raqamni tekshirib, qayta kiriting!")
            }
            if (action.payload?.status === 200 && action.payload?.data !== "") {
                toast.success(`${action.payload.data}`)
            } else {
                toast.error(`Ariza raqamni tekshirib, qayta kiriting!`)
            }
            state.isLoading = false
        },
        [getEpiguApplicationData.pending](state) {
            state.isLoading = true
        },
        [getEpiguApplicationData.rejected](state, action) {
            if (action.payload === undefined) {
                toast.error("500 Internal Server Error")
            }
            toast.error(action.payload)
            state.isLoading = false
        }
    }
})

export const {} = configSlice.actions

export default configSlice.reducer